<mat-form-field class="number-form-field" appearance="outline">
    <mat-label>{{normalizedLabel}}</mat-label>
    <input type="number" matInput name="{{label}}-{{key}}" 
        [required]="required" [disabled]="disabled" [readonly]="readonly"
        attr.data-testid="record-{{label}}-number"
        [(ngModel)]="value" (ngModelChange)="onFieldChange.emit($event)">
</mat-form-field>
